'use strict';
var detail = require('base/product/detail');
var addToCart = require('./addToCart');
var featuresVideoGrid = require('../experience/components/common/featuresVideoGrid');

let pdpCarouselLightBoxInstance = null;

function initPDPCarouselLightBox(){
    const PhotoSwipeLightbox = require('photoswipe/dist/photoswipe-lightbox.esm.js').default;
    const PhotoSwipe = require('photoswipe/dist/photoswipe.esm.js').default;

    const galleryElement = document.querySelector('.pdp-image-carousel');
    if(!galleryElement || galleryElement.dataset.lightbox === '0') return;

    const config = {
        gallery:'.pdp-image-carousel',
        children:'div:not(.slick-cloned) > a',
        showHideAnimationType: 'fade',
        pswpModule: PhotoSwipe
    };
    
    if(pdpCarouselLightBoxInstance){
        pdpCarouselLightBoxInstance.destroy();
        pdpCarouselLightBoxInstance = null;
    }

    try {
        pdpCarouselLightBoxInstance = new PhotoSwipeLightbox(config);
        pdpCarouselLightBoxInstance.init();
    } catch (error) {
        console.error('initPDPCarouselLightBox Error: ', error);
    }
}

function handleBreakpointChange(){
    const breakpoint = window.matchMedia('(max-width: 768px)');
    breakpoint.addEventListener('change', () => {
        initPDPCarouselLightBox();
    })
}

function initVideosComponent() {
    const videos = $('.pdp-videos')

    featuresVideoGrid.initVideoGrid(videos)
}

detail.addToCartCase = addToCart.addToCartCase;
detail.closeModalPromo = addToCart.closeModalPromo;
detail.closeModalPromoThanks = addToCart.closeModalPromoThanks;
detail.addToCart = addToCart.addToCart;
detail.addToCartSendData = addToCart.addToCartSendData;
detail.initPDPCarouselLightBox = initPDPCarouselLightBox;
detail.handleBreakpointChange = handleBreakpointChange;
detail.initVideosComponent = initVideosComponent;

module.exports = detail;
